import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home/index";
import Ding from "@/utils/dingding/config";
import leave from "@/pages/HR/Leave/index";
import comment from "@/components/Approval/comment/index";
import addApprover from "@/components/Approval/AddApprover/index";
import errors from "@/components/Share/Errors";
import purchase from "@/pages/FD/Purchase/index";
import borrowing from "@/pages/FD/Borrowing/index";
import travelExpenses from "@/pages/FD/TravelExpenses/index";
import reimbursement from "@/pages/FD/Reimbursement/index";
import invoice from "@/pages/FD/Invoice/index";
import personalReim from "@/pages/FD/PersonalReim/index";
import project from "@/pages/BD/Project/ProjrctApply";
import projectInfo from "@/pages/BD/Project/ProjectInfo";
import projectBudgetChange from "@/pages/BD/Project/ProjectBudgetChange";
Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      meta: { title: "首页" },
      component: Home
    },
    {
      path: "/HR/leave",
      name: "leave",
      meta: { title: "请假审批", isMore: true },
      component: leave
    },
    {
      path: "/comment",
      name: "comment",
      meta: {},
      component: comment
    },
    {
      path: "/addApprover",
      name: "addApprover",
      meta: { title: "加审批人" },
      component: addApprover
    },
    {
      path: "/errors",
      name: "errors",
      meta: { title: "系统错误" },
      component: errors
    },
    {
      path: "/FD/errors",
      name: "errors",
      meta: { title: "系统错误" },
      component: errors
    },
    {
      path: "/BD/errors",
      name: "errors",
      meta: { title: "系统错误" },
      component: errors
    },
    {
      path: "/FD/purchase",
      name: "purchase",
      meta: { title: "采购审批", isMore: true },
      component: purchase
    },
    {
      path: "/FD/borrowing",
      name: "borrowing",
      meta: { title: "借款审批", isMore: true },
      component: borrowing
    },
    {
      path: "/FD/travelExpenses",
      name: "travelExpenses",
      meta: { title: "差旅费审批", isMore: true },
      component: travelExpenses
    },
    {
      path: "/FD/reimbursement",
      name: "reimbursement",
      meta: { title: "报销审批", isMore: true },
      component: reimbursement
    },
    {
      path: "/FD/prepayment",
      name: "prepayment",
      meta: { title: "预付账款审批", isMore: true },
      component: reimbursement
    },
    {
      path: "/FD/invoice",
      name: "invoice",
      meta: { title: "开票审批", isMore: true },
      component: invoice
    },
    {
      path: "/FD/personalReim",
      name: "personalReim",
      meta: { title: "个人费用报销审批", isMore: true },
      component: personalReim
    },
    {
      path: "/BD/project",
      name: "project",
      meta: { title: "立项审批", isMore: true },
      component: project
    },
    {
      path: "/BD/projectInfo",
      name: "projectInfo",
      meta: { title: "项目信息", isMore: true },
      component: projectInfo
    },
    {
      path: "/BD/projectBudgetChange",
      name: "projectBudgetChange",
      meta: { title: "项目预算变更", isMore: true },
      component: projectBudgetChange
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题

    router.app.$options.store.commit("setTitleInfo", {
      title: to.meta.title,
      bg: "default",
      isMore: to.meta.isMore
    });
  }
  if (to.query.dd_full_screen) {
    var userInfo = router.app.$options.store.state.userInfo;
    if (userInfo.employeeID) {
      next(); //执行进入路由，如果不写就不会进入目标页
    } else {
      let auth = await Ding();
      if (auth.success) {
        // auth.data.employeeID = 'EM00001392';
        router.app.$options.store.commit("setUserInfo", auth.data);
        next();
      } else {
        //       console.log('报错');
        // router.app.$options.store.commit("setUserInfo", {
        //   employeeID: "EM00000294",
        //   postID: "PT0084"
        // });
        next();
      }
    }
  } else {
    let query = { dd_full_screen: true, ...to.query };
    next({
      path: to.path,
      query
    });
  }
});
router.afterEach(async (to, from) => {
  if (router.app.$options.store.state.historyPageName == "") {
    router.app.$options.store.commit("setHistoryPageName", to.name);
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js